<template>
    <div>
        <div v-if="!isLoadingHierarquia">
            <v-row>
                <v-col
                    v-for="(item, index) in arrUnimeds"
                    :key="index"
                    cols="3"
                    :style="topSpace(arrUnimeds, index)"
                >
                    <hierarquia-card
                      ref="hierarquiaCard"
                      :currentUnit="index === arrUnimeds.length - 1"
                      :unidadeID="item.codigo"
                      :unidadeName="item.nomeFantasia"
                      :tipoCooperativa="item.tipoUnimed ? item.tipoUnimed.nome : ''"
                      :tipoAtuacao="item.tipoAtuacao ? item.tipoAtuacao.nome : ''"
                      :comboBox="index === arrUnimeds.length - 2"
                      :listaUnimeds="listaAcimaUnimed"
                      :value="objEdicaoHierarquia.unimedPai ? objEdicaoHierarquia.unimedPai.textoExibicao : ''"
                      @input="chamarInfo"
                    />
                </v-col>
            </v-row>
        </div>
        <component-loading :value="isLoadingHierarquia"/>
        <error-modal
            :value="showError"
            @input="fecharModal"
            :errObj="errObj"
        />
    </div>
</template>

<script>
import Hierarquia from '@/services/Hierarquia'

export default {
  data () {
    return {
      tokenBearer: localStorage.getItem('tokenBearer'),
      idUnimed: '',
      showError: false,
      errObj: {},
      listaAcimaUnimed: [],
      objEdicaoHierarquia: {},
      arrUnimeds: [],
      isLoadingHierarquia: false,
      errors: ''
    }
  },
  beforeMount () {
    this.idUnimed = this.$idUnimed
    this.start()
  },
  methods: {
    chamarInfo (obj) {
      this.objEdicaoHierarquia.unimedPai = {
        id: obj.id,
        textoExibicao: obj.nome
      }
      this.loadFunc(this.infoHierarquia)
    },
    async loadFunc (fun) {
      this.isLoadingHierarquia = true
      await fun()
      this.isLoadingHierarquia = false
    },
    topSpace (hierarquia, index) {
      return index === hierarquia.length - 1 ? { 'position': 'relative', 'top': 60 * index + 'px' } : { 'position': 'relative', 'top': 56 * index + 'px' }
    },
    fecharModal () {
      this.showError = false
    },
    async start () {
      this.hierarquia = new Hierarquia(this.tokenBearer, this.$appConfig.config.API, 0)
      try {
        this.isLoadingHierarquia = true
        const promiseArr = [await this.iniciaEdicao(), await this.infoHierarquia(), await this.carregaListaUnimedsAcima()]
        await Promise.all(promiseArr)
      } catch (err) {
        this.setError(err)
      } finally {
        this.isLoadingHierarquia = false
      }
    },
    async carregaListaUnimedsAcima () {
      try {
        const response = await this.hierarquia.paisHierarquia(this.idUnimed)
        this.listaAcimaUnimed = response.data
      } catch (err) {
        this.setError(err)
      }
    },
    async iniciaEdicao () {
      try {
        let response = await this.hierarquia.getUnimedEdicao(this.idUnimed)
        response = response.data
        response.ignorarAvo = response.ignorarAvo || false
        this.objEdicaoHierarquia = response
      } catch (err) {
        this.valueData = false
        this.abrirModalNovamente = true
        this.setError(err)
      }
    },
    async infoHierarquia () {
      try {
        let response = await this.hierarquia.infoHierarquia(this.objEdicaoHierarquia)
        response = response.data

        const arr = response.hierarquiaAcimaResultante
        const len = arr.length

        this.arrUnimeds = len === 1 ? [{}, arr[0]] : arr
      } catch (err) {
        this.setError(err)
      }
    },
    async salvarHierarquia () {
      const hierarquias = await this.$refs.hierarquiaCard
      const valid = await hierarquias[hierarquias.length - 2].validate()
      if (valid) {
        try {
          await this.hierarquia.finalizarEdicao(this.objEdicaoHierarquia)
          return true
        } catch (err) {
          this.setError(err)
          return false
        }
      }
    },
    setError (err) {
      this.valuedData = false
      this.error = true
      this.showError = true
      console.error(err)
      this.errObj.status = err.response.status
      this.errObj.error = err.response.data.message
      this.isLoadingHierarquia = false
    }
  }
}
</script>

<style>

</style>
